// Error Boundary Component
// Catches JavaScript errors anywhere in the component tree and displays a fallback UI

import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to an error reporting service
    console.error('Error caught by boundary:', error, errorInfo);

    this.setState({
      error: error,
      errorInfo: errorInfo
    });

    // You can also log to an external service here
    // Example: logErrorToService(error, errorInfo);
  }

  handleReset = () => {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null
    });
  };

  render() {
    if (this.state.hasError) {
      // Fallback UI
      return (
        <div style={{
          padding: '40px',
          maxWidth: '800px',
          margin: '0 auto',
          textAlign: 'center'
        }}>
          <h1 style={{ color: '#e53e3e', marginBottom: '20px' }}>
            Oops! Something went wrong
          </h1>
          <p style={{ fontSize: '18px', color: '#4a5568', marginBottom: '30px' }}>
            We're sorry for the inconvenience. An error occurred while loading this page.
          </p>

          {process.env.NODE_ENV === 'development' && this.state.error && (
            <details style={{
              backgroundColor: '#f7fafc',
              padding: '20px',
              borderRadius: '8px',
              textAlign: 'left',
              marginBottom: '20px',
              border: '1px solid #e2e8f0'
            }}>
              <summary style={{
                cursor: 'pointer',
                fontWeight: 'bold',
                marginBottom: '10px',
                color: '#2d3748'
              }}>
                Error Details (Development Only)
              </summary>
              <p style={{ color: '#e53e3e', fontFamily: 'monospace', fontSize: '14px' }}>
                {this.state.error.toString()}
              </p>
              <pre style={{
                backgroundColor: '#2d3748',
                color: '#f7fafc',
                padding: '15px',
                borderRadius: '4px',
                overflow: 'auto',
                fontSize: '12px',
                marginTop: '10px'
              }}>
                {this.state.errorInfo.componentStack}
              </pre>
            </details>
          )}

          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
            <button
              onClick={this.handleReset}
              style={{
                backgroundColor: '#667eea',
                color: 'white',
                padding: '12px 24px',
                border: 'none',
                borderRadius: '6px',
                fontSize: '16px',
                cursor: 'pointer',
                fontWeight: '500'
              }}
            >
              Try Again
            </button>
            <button
              onClick={() => window.location.href = '/'}
              style={{
                backgroundColor: '#48bb78',
                color: 'white',
                padding: '12px 24px',
                border: 'none',
                borderRadius: '6px',
                fontSize: '16px',
                cursor: 'pointer',
                fontWeight: '500'
              }}
            >
              Go to Home
            </button>
          </div>

          <p style={{
            marginTop: '30px',
            fontSize: '14px',
            color: '#718096'
          }}>
            If the problem persists, please contact support.
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
